'use client'

import { useEffect, useRef } from 'react'

import { getPopupMessage, showPopup } from '../lib/popup'
import { copyURL, getSuccessMessage, getURL } from '../lib/url-copy'

type Props = {
  html: string
}

export const SanitizedContent = ({ html }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const handleImageClick = async (event: MouseEvent) => {
      const target = event.target as HTMLElement

      // URL 복사

      const url = getURL(target)

      if (url) {
        const successMessage = getSuccessMessage(target)
        await copyURL({ url, successMessage })
      }

      // Alert 표시

      const popupMessage = getPopupMessage(target)

      if (popupMessage) {
        showPopup(popupMessage)
      }
    }

    container.addEventListener('click', handleImageClick)

    return () => {
      container.removeEventListener('click', handleImageClick)
    }
  }, [])

  return <div ref={containerRef} dangerouslySetInnerHTML={{ __html: html }} />
}
